import React from "react";
import PropTypes from "prop-types";
import "./HuiPage.scss";
import { GiraffeLoader, HBreadcrumb, Header } from "../index";
import GiraffeImg from "../GiraffeLoader/giraffe-loader-animated.gif";
import { Grid } from "semantic-ui-react";

export const HuiPage = ({
  title = null,
  breadcrumbs = [],
  description,
  breadcrumbComponent,
  loading = false,
  fullPageLoading = false,
  ctaComponents,
  ...props
}) => {
  if (fullPageLoading)
    return (
      <GiraffeLoader image={props.loadingImage || GiraffeImg} height="200px" />
    );

  return (
    <div className={`hireart-ds-page page-chrome-bounds ${props.className}`}>
      <div className="hireart-ds-page-breadcrumbs">
        {breadcrumbComponent !== undefined ? (
          breadcrumbComponent
        ) : (
          <HBreadcrumb sections={breadcrumbs} />
        )}
      </div>
      <Grid verticalAlign="middle" columns="equal">
        {(title || description) && (
          <Grid.Column
            width={ctaComponents === undefined ? 16 : 8}
            className="page-header-text"
          >
            <div className="page-header-text">
              <Header text={title} size="h4" />
            </div>
            <div className="page-description-text">{description}</div>
          </Grid.Column>
        )}
        {ctaComponents !== undefined && (
          <Grid.Column>
            <div className="header-cta">{ctaComponents}</div>
          </Grid.Column>
        )}
      </Grid>

      <div className={`hireart-ds-page-content ${loading && "page-loading"}`}>
        {loading ? (
          <GiraffeLoader
            image={props.loadingImage || GiraffeImg}
            height="200px"
          />
        ) : (
          props.children
        )}
      </div>
    </div>
  );
};

HuiPage.propTypes = {
  breadcrumbs: PropTypes.array,
  breadcrumbComponent: PropTypes.element,
  ctaComponents: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  fullPageLoading: PropTypes.bool,
  loadingImage: PropTypes.string,
};

